/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
import { Input2, DropDown2 } from "components";
import { useInput } from "hooks";
import { ALL_COUPON_TYPES_PREDICTIVE_TEXT } from "config";

export const OfferFreeWithTextBuilder = ({
  className,
  value,
  onChange = () => {},
}) => {
  const suffix = useInput("");
  const type = useInput("");
  
  const handleUpdateValue = (t, s) => {
    onChange(t ? `Free w/${t}${s ? ` ${s}` : ""}` : `Free w/${s}`);
  };

  useEffect(() => {
    if (value && value.startsWith("Free w/")) {
      const main = value.slice(7).trim();
      const sortedCouponTypes = [...ALL_COUPON_TYPES_PREDICTIVE_TEXT]
        .filter((c) => c.id)
        .sort((a, b) => b.id.length - a.id.length);

      let matchedType = "";
      let suffixText = "";

      for (const couponType of sortedCouponTypes) {
        if (main?.toLowerCase().startsWith(couponType.id.toLowerCase())) {
          matchedType = couponType.id;
          suffixText = main.slice(couponType.id.length).trim();
          break;
        }
      }
      
      if(matchedType) {
        type.setValue(matchedType);
        suffix.setValue(suffixText);
      } else {
        // fallback for backward compatibility or if no type matches
        type.setValue("");
        suffix.setValue(main)
      }
    }
    return () => {};
  }, [value]);

  return (
    <div className={`${className} mt-1 p-2`}>
      <Title>Offer Text Builder</Title>
      <Container className="mt-2">
        <div className="mt-auto mb-1">Free w/ </div>
        <div style={{ width: 120, marginLeft: 10 }}>
          <DropDown2
            label="Coupon"
            data={ALL_COUPON_TYPES_PREDICTIVE_TEXT}
            width={120}
            value={type.value}
            onChange={(e) => {
              type.setValue(e);
              handleUpdateValue(e, suffix.value);
            }}
          />
        </div>
        <div style={{ width: 100, marginLeft: 10 }}>
          <Input2
            label="Suffix"
            value={suffix.value}
            onChange={(e) => {
              suffix.setValue(e);
              handleUpdateValue(type.value, e);
            }}
          />
        </div>
      </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px;
  display: flex;
`;
